import { formatAsFileSize } from 'cpfr-common';
import { FileUpload as SharedFileUpload } from '@cp-shared-19/frontend-ui';
import React, { AnchorHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { maxFileSize } from '../../../../../../../config';
import { Layout, Paragraph } from '@vwfs-bronson/bronson-react';

export type FileUploadProps = { name: string; label?: string; isMandatory?: boolean; multiple?: boolean };

export const FileUpload: React.FC<FileUploadProps> = ({ name, label, isMandatory = true, multiple = false }) => {
    const { t } = useTranslation('request');
    const sizeError = t('file-upload.size-error');
    const typeError = t('file-upload.type-error');

    const secondaryButtonsProps: AnchorHTMLAttributes<HTMLAnchorElement> = {
        title: t('file-upload.delete-file-aria-label'),
        'aria-label': t('file-upload.delete-file-aria-label'),
    };

    const sizeAndTypeError = (
        <Layout>
            <Layout.Item>
                <Paragraph>{sizeError}</Paragraph>
            </Layout.Item>
            <Layout.Item>
                <Paragraph>{typeError}</Paragraph>
            </Layout.Item>
        </Layout>
    );
    return (
        <>
            {label && (
                <p
                    dangerouslySetInnerHTML={{
                        __html: isMandatory ? `${label}<span aria-hidden="true"> *</span>` : label,
                    }}
                    className={'u-mb-xsmall'}
                />
            )}
            <SharedFileUpload
                name={name}
                uploadItemsLabel=""
                descriptionText={t('file-upload.headline')}
                descriptionSupplementaryText={t('file-upload.text')}
                buttonText={t('file-upload.button')}
                cancelLabel={t('translation:editable-section-nav.cancel')}
                fileSizeFormatter={(bytes: number): string => formatAsFileSize(bytes, 2)}
                maxFileSize={maxFileSize}
                validFileFormats={['pdf']}
                sizeError={sizeError}
                typeError={typeError}
                sizeAndTypeError={sizeAndTypeError}
                secondaryButtonProps={secondaryButtonsProps}
                multiple={multiple}
            />
        </>
    );
};
